import { convertLength } from '@turf/turf';

export type PaceUnit = 'miles' | 'kilometers';

export function convertPace(
  paceInSeconds: number,
  from: 'meters',
  to: 'miles' | 'kilometers',
) {
  try {
    const convertedSeconds = 1 / convertLength(paceInSeconds, from, to);
    return convertedSeconds;
  } catch (error) {
    console.error(error);
    return paceInSeconds;
  }
}
